import axiosClient from "./axiosClient";

function toQueryString(params = {}) {
  const searchParams = new URLSearchParams();
  Object.entries(params).forEach(([key, value]) => {
    if (value !== undefined && value !== null && value !== "") {
      searchParams.append(key, value);
    }
  });
  const query = searchParams.toString();
  return query ? `?${query}` : "";
}

export async function getProducts(params) {
  const response = await axiosClient.get(`/Products${toQueryString(params)}`);
  return response.data;
}

export async function getProductById(id, source) {
  const response = await axiosClient.get(`/Products/${id}${toQueryString({ source })}`);
  return response.data;
}

export async function getMyProducts(storeId) {
  const response = await axiosClient.get(`/Products/mine${toQueryString({ storeId })}`);
  return response.data;
}

// Applies or removes a discount on many products at once (see BulkDiscountRequest on the backend).
export async function bulkDiscountProducts(payload) {
  const response = await axiosClient.post(`/Products/bulk-discount`, payload);
  return response.data;
}

export async function getDeletedProducts(storeId) {
  const response = await axiosClient.get(`/Products/deleted${toQueryString({ storeId })}`);
  return response.data;
}

export async function createProduct(payload) {
  const response = await axiosClient.post(`/Products`, payload);
  return response.data;
}

export async function updateProduct(id, payload) {
  const response = await axiosClient.put(`/Products/${id}`, payload);
  return response.data;
}

export async function deleteProduct(id) {
  await axiosClient.delete(`/Products/${id}`);
}

export async function restoreProduct(id) {
  const response = await axiosClient.post(`/Products/${id}/restore`);
  return response.data;
}

export async function deleteProductPermanently(id) {
  await axiosClient.delete(`/Products/${id}/permanent`);
}

export async function uploadProductImage(id, file) {
  const formData = new FormData();
  formData.append("file", file);
  const response = await axiosClient.post(`/Products/${id}/images`, formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });
  return response.data;
}

export async function addProductImageFromUrl(id, imageUrl, referer) {
  const response = await axiosClient.post(`/Products/${id}/images/from-url`, { imageUrl, referer: referer || undefined });
  return response.data;
}

export async function removeProductImageBackground(id, imageId) {
  const response = await axiosClient.post(`/Products/${id}/images/${imageId}/remove-background`);
  return response.data;
}

export async function replaceProductImage(id, imageId, file) {
  const formData = new FormData();
  formData.append("file", file);
  const response = await axiosClient.put(`/Products/${id}/images/${imageId}`, formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });
  return response.data;
}

export async function deleteProductImage(id, imageId) {
  const response = await axiosClient.delete(`/Products/${id}/images/${imageId}`);
  return response.data;
}

export async function setMainProductImage(id, imageId) {
  const response = await axiosClient.post(`/Products/${id}/images/${imageId}/main`);
  return response.data;
}

export async function uploadProductVideo(id, file) {
  const formData = new FormData();
  formData.append("file", file);
  const response = await axiosClient.post(`/Products/${id}/video`, formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });
  return response.data;
}

export async function deleteProductVideo(id) {
  const response = await axiosClient.delete(`/Products/${id}/video`);
  return response.data;
}

export async function createProductVariant(id, payload) {
  const response = await axiosClient.post(`/Products/${id}/variants`, payload);
  return response.data;
}

export async function updateProductVariant(id, variantId, payload) {
  const response = await axiosClient.put(`/Products/${id}/variants/${variantId}`, payload);
  return response.data;
}

export async function deleteProductVariant(id, variantId) {
  const response = await axiosClient.delete(`/Products/${id}/variants/${variantId}`);
  return response.data;
}

export async function uploadVariantImage(id, variantId, file) {
  const formData = new FormData();
  formData.append("file", file);
  const response = await axiosClient.post(`/Products/${id}/variants/${variantId}/image`, formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });
  return response.data;
}

export async function addVariantImageFromUrl(id, variantId, imageUrl, referer) {
  const response = await axiosClient.post(`/Products/${id}/variants/${variantId}/image/from-url`, {
    imageUrl,
    referer: referer || undefined,
  });
  return response.data;
}

export async function removeVariantImageBackground(id, variantId) {
  const response = await axiosClient.post(`/Products/${id}/variants/${variantId}/image/remove-background`);
  return response.data;
}

export async function deleteVariantImage(id, variantId) {
  const response = await axiosClient.delete(`/Products/${id}/variants/${variantId}/image`);
  return response.data;
}

export async function getAuthenticityOptions() {
  const response = await axiosClient.get(`/AuthenticityOptions`);
  return response.data;
}
